import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from 'app/store';

import { generateParams } from 'features/filters/filtersSlice';
import JobsService from 'features/jobs/jobsService';

import { SortOrders } from 'types/filters';

import { MAX_DASHBOARD_JOBS_TO_SHOW } from 'constants/uiSettings';

export const fetchJobsData = createAsyncThunk(
  'jobs/getJobs',
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const params = generateParams(state.filters);

    try {
      const response = await JobsService.getJobs(params);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchActiveJobDetails = createAsyncThunk(
  'jobs/fetchActiveJobDetails',
  async (jobId: string, { rejectWithValue }) => {
    try {
      const response = await JobsService.getJobById(jobId);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchFreeJobsInfo = createAsyncThunk(
  'jobs/fetchFreeJobsInfo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await JobsService.getFreeJobsInfo();

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchJobsForDashboard = createAsyncThunk(
  'jobs/fetchJobsForDashboard',
  async (_, { rejectWithValue }) => {
    try {
      const params = generateParams({
        sortField: 'createdDate',
        sortOrder: SortOrders.Asc,
        pageSize: MAX_DASHBOARD_JOBS_TO_SHOW
      });

      const response = await JobsService.getJobs(params);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
